<template>
  <div class="tour">
    <v-tour
      :options="allOptions"
      :name="name"
      :steps="steps"
      :callbacks="myCallbacks"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'GeneralTour',

  props: {
    name: {
      required: true,
    },
    steps: {
      required: true,
    },
    options: {
      type: Object,
      default: () => {},
    },

  },
  data () {
    return {
      window,
      default_options: {
        labels: {
          buttonSkip: Lang.get('core.skip_tour'),
          buttonPrevious: Lang.get('core.previous'),
          buttonNext: Lang.get('core.next'),
          buttonStop: Lang.get('core.finish'),
        },
      },
      myCallbacks: {
        onNextStep: this.myCustomNextStepCallback,
        onStop: this.myCustomStopCallback,
      },
      progress: 0,
    }
  },
  computed: {

    allOptions () {
      return { ...this.default_options, ...this.options }
    },
  },

  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },

    myCustomNextStepCallback (currentstep) {
      this.progress = this.progress + 1
      this.$emit('onNextStep', currentstep)
    },

    myCustomStopCallback () {
      axios.post('/tour/stop', { tour: this.name, step: this.progress + 1 }).then(() => {
        this.progress = 0
      }).catch(error => defaultErrorMessage(error))
      this.$emit('onStop')
    },
  },

}
</script>

<style>
    .tour {
        z-index: 40000;
    }
</style>
